import React, { useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import SaveButton from '../components/atoms/SaveButton';
import MessageBar from '../components/organisms/MessageBar';
import StationBoard from '../components/organisms/StationBoard';
import { vw } from '../constants/size';

const styles = StyleSheet.create({
	container: {
		flex: 1,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	header: {
		position: 'absolute',
		top: 0,
		width: vw,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	footer: {
		position: 'absolute',
		bottom: 0,
		width: vw,
	},
});

const HomeScreen: React.VFC = () => {
	const captureTargetRef = useRef<View>(null);
	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<SaveButton captureTargetRef={captureTargetRef} />
			</View>
			<View ref={captureTargetRef} collapsable={false}>
				<StationBoard />
			</View>
			<View style={styles.footer}>
				<MessageBar />
			</View>
		</View>
	);
};

export default HomeScreen;
